import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DiscoveryCallForm from "@/components/DiscoveryCallForm";
import CollaborationForm from "@/components/CollaborationForm";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 md:pt-24 pb-12">
        <p className="overline fade-up"><span className="section-mark">Contact</span></p>
        <h1 className="font-display mt-7 text-[44px] sm:text-6xl md:text-7xl font-light tracking-[-0.03em] leading-[0.98] text-ink fade-up fade-up-2">
          Let's talk.<br />Pick the door <span className="font-display-italic">that fits</span>.
        </h1>
        <p className="mt-8 max-w-2xl text-[15px] sm:text-lg text-ink-soft leading-[1.7] fade-up fade-up-3">
          Two intents, one place. Choose the form that matches what you're here for —
          financial advisory or a brand collaboration.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-8">
          <Tabs defaultValue="discovery" className="w-full" data-testid="contact-tabs">
            <TabsList className="bg-transparent p-0 h-auto gap-2 mb-10 flex flex-wrap">
              <TabsTrigger
                value="discovery"
                data-testid="tab-discovery"
                className="rounded-full border border-stone-300 px-5 py-2.5 data-[state=active]:bg-ink data-[state=active]:text-white data-[state=active]:border-ink text-[13px] font-medium tracking-wide"
              >
                Book a Discovery Call
              </TabsTrigger>
              <TabsTrigger
                value="collab"
                data-testid="tab-collab"
                className="rounded-full border border-stone-300 px-5 py-2.5 data-[state=active]:bg-terracotta data-[state=active]:text-white data-[state=active]:border-terracotta text-[13px] font-medium tracking-wide"
              >
                Brand Collaboration
              </TabsTrigger>
            </TabsList>

            <TabsContent value="discovery" className="mt-0">
              <div className="rounded-2xl border border-[hsl(var(--line))] bg-white p-7 sm:p-10 md:p-12">
                <p className="overline"><span className="section-mark">For clients</span></p>
                <h2 className="font-display mt-5 text-3xl md:text-4xl font-light tracking-[-0.02em] text-ink leading-[1.15]">
                  Tell us about<br /><span className="font-display-italic">your requirement</span>.
                </h2>
                <p className="mt-5 text-ink-soft text-[15px] max-w-lg leading-[1.7]">
                  A 30–45 minute call to understand your situation. No charge, no obligation.
                </p>
                <div className="mt-10">
                  <DiscoveryCallForm />
                </div>
              </div>
            </TabsContent>

            <TabsContent value="collab" className="mt-0">
              <div className="rounded-2xl border border-[hsl(var(--line))] bg-white p-7 sm:p-10 md:p-12">
                <p className="overline"><span className="section-mark">For brand teams</span></p>
                <h2 className="font-display mt-5 text-3xl md:text-4xl font-light tracking-[-0.02em] text-ink leading-[1.15]">
                  Pitch your<br /><span className="font-display-italic">campaign</span>.
                </h2>
                <p className="mt-5 text-ink-soft text-[15px] max-w-lg leading-[1.7]">
                  Share the brief, deliverables and timelines. We'll come back with a fit and
                  a price.
                </p>
                <div className="mt-10">
                  <CollaborationForm />
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>

        <aside className="lg:col-span-4 lg:pl-6">
          <div className="lg:sticky lg:top-28 space-y-8">
            <div>
              <p className="overline"><span className="section-mark">Direct</span></p>
              <ul className="mt-5 space-y-4 text-ink text-[15px]">
                <li className="flex items-start gap-3" data-testid="contact-email">
                  <Mail size={16} className="mt-1 text-terracotta" />
                  <a href="mailto:teamcanitin@gmail.com" className="hover:text-terracotta">
                    teamcanitin@gmail.com
                  </a>
                </li>
                <li className="flex items-start gap-3" data-testid="contact-phone">
                  <Phone size={16} className="mt-1 text-terracotta" />
                  <a href="tel:+919871143039" className="hover:text-terracotta">
                    +91 98711 43039
                  </a>
                </li>
                <li className="flex items-start gap-3" data-testid="contact-location">
                  <MapPin size={16} className="mt-1 text-terracotta" />
                  <span>Delhi, India</span>
                </li>
              </ul>
            </div>

            <div className="rounded-2xl border border-[hsl(var(--line))] bg-white p-7">
              <p className="overline"><span className="section-mark">Faster</span></p>
              <p className="font-display mt-4 text-2xl font-light tracking-tight text-ink leading-tight">
                Prefer <span className="font-display-italic">WhatsApp</span>?
              </p>
              <p className="mt-3 text-ink-soft text-[14px] leading-relaxed">
                Tap the green floating button to chat directly. Replies usually within
                business hours.
              </p>
            </div>

            <div className="rounded-2xl bg-ink text-white p-7">
              <p className="text-[10px] tracking-[0.22em] uppercase font-semibold opacity-70">Office hours</p>
              <p className="font-display mt-4 text-xl font-light leading-snug tabular">
                Mon — Sat<br />10:00 — 19:00 IST
              </p>
            </div>
          </div>
        </aside>
      </section>
    </>
  );
}
